import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import { MEETING_TYPES_NAMES } from '@/meetings/values/meetings.values';
import i18n from '../../../content/lang/content.i18n';

@Component({})
export default class EdMeetingModal extends Vue {
  
  /* Arguments */
  @Prop() readonly params:any;

  /* Data */
  public meetingTypes:any = [
    i18n.t(`menu.${MEETING_TYPES_NAMES.TOHAINA}`),
    i18n.t(`menu.${MEETING_TYPES_NAMES.ETHERPAD}`),
    i18n.t(`menu.${MEETING_TYPES_NAMES.WHITEBOARD}`) ]
  public icons:any = ['file-video-solid','file-alt-solid','file-signature-solid']

  /* Methods */
  public clickOption(value:number){
      switch (value) {
        case 0:
            window.open(this.params.data.url, '_blank');
            break;
        
        case 1:
            window.open(this.params.data.padUrl, '_blank');
            break;

        case 2:
            window.open(this.params.data.boardUrl, '_blank');
            break;
      }
  }

  public closeModal(){
    this.$EdModal.closeModal();
  }
} 